// Need to use the React-specific entry point to import createApi
import moment from 'moment';
import forOwn from 'lodash/forOwn';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';

import {apiSlice} from './apiSlice';

const getDateTimeRange = ({monthNum, year}) => {
  const start_time = moment(`${year}-${monthNum}-01`, 'yyyy-MM-DD')
    .startOf('month')
    .toISOString();
  const end_time = moment(start_time)
    .endOf('month')
    .toISOString();
  return {start_time, end_time};
};

// Define a service using a base URL and expected endpoints
export const availabilityApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAvailabilities: builder.query({
      query: ({providerId, session_type_id, start_time, end_time}) => {
        const qs = new URLSearchParams();
        qs.set('session_type_id', parseInt(session_type_id, 10));
        console.log('start_time', start_time);
        if (start_time) qs.set('start_time', start_time);
        if (end_time) qs.set('end_time', end_time);
        return `/availability/${parseInt(providerId)}/?${qs}`;
      },
      providesTags: ['Availability'],
    }),
    getAvailabilitiesForMonth: builder.query({
      query: ({providerId, session_type_id, monthNum, year}) => {
        const qs = new URLSearchParams();
        qs.set('session_type_id', parseInt(session_type_id, 10));
        const range = getDateTimeRange({monthNum, year});
        if (range.start_time) qs.set('start_time', range.start_time);
        if (range.end_time) qs.set('end_time', range.end_time);
        return `/availability/${parseInt(providerId, 10)}/?${qs}`;
      },
      providesTags: ['Availability'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAvailabilitiesQuery,
  useGetAvailabilitiesForMonthQuery,
} = availabilityApi;
